import { qcAxios } from '../../api/axiosQcClient';

const BASE = '/api/notificationData';

/**
 * Caller's notifications, newest first.
 * Endpoint: `GET /api/notificationData/getNotifications?beforeId=&limit=`
 * @returns {Promise<{ items: object[], nextBeforeId: number | null }>}
 */
export async function getNotifications({ beforeId, limit } = {}) {
  const { data: body } = await qcAxios.get(`${BASE}/getNotifications`, {
    params: { beforeId: beforeId ?? undefined, limit },
  });
  return {
    items: body?.data?.items ?? [],
    nextBeforeId: body?.data?.nextBeforeId ?? null,
  };
}

/** Endpoint: `GET /api/notificationData/getUnreadCount` → number */
export async function getUnreadNotificationCount() {
  const { data: body } = await qcAxios.get(`${BASE}/getUnreadCount`);
  return body?.data?.count ?? 0;
}

/** Endpoint: `POST /api/notificationData/markRead` body `{ ids }` */
export async function markNotificationsRead(ids) {
  await qcAxios.post(`${BASE}/markRead`, { ids });
}

/** Endpoint: `POST /api/notificationData/markAllRead` */
export async function markAllNotificationsRead() {
  await qcAxios.post(`${BASE}/markAllRead`);
}

/** SSE stream path (opened with fetch-event-source, not axios). */
export const NOTIFICATION_STREAM_PATH = `${BASE}/stream`;
